import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowTop = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 6C12.2652 6 12.5196 6.10536 12.7071 6.29289L20.7071 14.2929C21.0976 14.6834 21.0976 15.3166 20.7071 15.7071C20.3166 16.0976 19.6834 16.0976 19.2929 15.7071L12 8.41421L4.70711 15.7071C4.31658 16.0976 3.68342 16.0976 3.29289 15.7071C2.90237 15.3166 2.90237 14.6834 3.29289 14.2929L11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6Z"
          fill={color}
        />
      </svg>
    );
  },
);
